import AboutImage from '../assets/img-about.png';
import AboutImageMedium from '../assets/img-about-medium.png';
import Interface from '../assets/interface.png';
import InterfaceMedium from '../assets/interface-medium.png';

function SectionFive() {
  return (
    <section className="section-5">
      <div>
        <picture>
          <source media="(min-width: 768px)" srcSet={AboutImageMedium} />
          <img src={AboutImage} alt="" className="w-full" />
        </picture>
      </div>
      <div className="max-h-[640px] overflow-hidden">
        <picture>
          <source media="(min-width: 768px)" srcSet={InterfaceMedium} />
          <img src={Interface} alt="" className="w-full" />
        </picture>
      </div>
    </section>
  );
}

export default SectionFive;
